module.exports = "/images/foodborne-disease@3x.png?7d999dd68a8f1fa385ce57feb4162715";